// extracted by mini-css-extract-plugin
module.exports = {"block":"Survey_block__1wPFz","title":"Survey_title__3VkxS","text":"Survey_text__1bI-b","button":"Survey_button__3lJ0M","icon":"Survey_icon__LvFlp"};